<template>
  <div class="sure-vin-wrap">
    <button type="button" v-show="!loading" @click="btnClick" :class="{ 'sure-vin-active' : sure }" class="sure-btn">{{btnTxt}}</button>
    <i v-show="loading" class="sure-vin-loading"></i>
  </div>
</template>
<script>
export default {
  props: {
    btnFunc: {
      required: true,
      type: Function
    },
    loading: {
      required: true,
      type: Boolean,
      default: false
    },
    sure: {
      required: true,
      type: Boolean,
      default: false
    },
    btnTxt: {
      required: true,
      type: String,
      default: '识别'
    }
  },
  data() {
    return {}
  },
  methods: {
    btnClick() {
      this.btnFunc()
    }
  }
}
</script>

<style lang="less" scoped>
@w2: 75rem;
.sure-btn {
  width: 110 /@w2;
  height: 50 /@w2;
  line-height: 50 /@w2;
  font-size: 26/@w2;
  border-radius: 25/@w2;
  background-color: #3b5999;
  color: #ffffff;
  text-align: center;
}
.sure-btn.sure-vin-active {
  background-color: #e7e7e9;
  color: rgba(0, 0, 0, 0.4);
}

.sure-vin-wrap {
  float: right;
  line-height: 2.26666667;
}
// loading 加载按钮
.sure-vin-loading {
  position: relative;
  top: 14 / @w2;
  right: 30 / @w2;
  background-color: #e7e7e9;
  width: 36 / @w2;
  height: 36 / @w2;
  border-radius: 100%;
  animation-fill-mode: both;
  border: 2 / @w2 solid #e7e7e9;
  border-bottom-color: transparent;
  background: transparent !important;
  display: inline-block;
  animation: vinLoadingRotate 0.75s 0s linear infinite;
}

// loading 加载动画
@keyframes vinLoadingRotate {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
